import { SelectedDuctedSystemType, SelectedSystemType } from 'data/types';

export function stripQuoteOnlyFields<
  T extends SelectedSystemType | SelectedDuctedSystemType
>(system: T): T {
  return {
    ...system,
    tax: undefined,
    shipping: undefined,
    rebates: undefined,
    totalRebates: undefined,
    quoteStatus: undefined
  };
}
